/**
 * @generated SignedSource<<7896ef110f9246521e45f0321a498597>>
 * @relayHash 18ddcc3405d47b3e8a49048770d8854b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf1bddd448997e0a4b36eb021a1605c73d29a7406cb035f377b1ba1c4bd57e0e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { LinkedGoalsQuery } from './LinkedGoalsQuery.graphql';

const node: PreloadableConcreteRequest<LinkedGoalsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bf1bddd448997e0a4b36eb021a1605c73d29a7406cb035f377b1ba1c4bd57e0e",
    "metadata": {},
    "name": "LinkedGoalsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
